import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import Role from "../domain/auth/Role";
import RolePermission from "../domain/auth/RolePermission";

class RoleService {

    readonly basePath = "/roles";

    public add(role: Role): Promise<string> {
        return Axios.post(`${this.basePath}`, role).then(value => value.data.id)
    }

    public addPermission(role: Role, rolePermission: RolePermission): Promise<void> {
        return Axios.post(`${this.basePath}/${role.id}/permissions`, rolePermission);
    }

    public update(roleId: string, role: Role): Promise<void> {
        return Axios.put(`${this.basePath}/${roleId}`, role);
    }

    public get(id: string): Promise<Role> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => Role.fromPOJO(value.data))
    }

    public delete(role: Role): Promise<void> {
        return Axios.delete(`${this.basePath}/${role.id}`);
    }

    public deletePermission(role: Role, rolePermission: RolePermission): Promise<void> {
        return Axios.delete(`${this.basePath}/${role.id}/permissions/${rolePermission.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<Role>> {
        return Axios.get(`${this.basePath}?${queryOptions.toQueryParams()}`)
            .then(value => {
                const objectList: Role[] = [];

                value.data.data.forEach((objectJson: object) => {
                    objectList.push(Role.fromPOJO(objectJson));
                });

                return new PagedResult(value.data.total, objectList);
            })
    }

}

export default RoleService;
